module.exports = __webpack_public_path__ + "static/media/tsb2ru.2d9ddb9c.pdf";